import React, { useContext } from 'react';
import { HeaderScrollContext } from './HeaderSubtitle';

// A page-header title that shrinks when the sticky header condenses on scroll.
// It shrinks via font-size (a real layout property) rather than a transform, so
// it transitions smoothly AND reclaims its own vertical space — composing
// cleanly with the subtitle collapse (no measuring, no transforms, no layout
// jumps). em-based letter-spacing scales with the font, so tracking stays
// proportional.
//
// Pass the expanded size class in `size` and the condensed one in
// `sizeScrolled`; both may include responsive variants
// (e.g. "text-[27px] lg:text-[64px]"). `as` sets the tag (default h1).
const HeaderTitle = ({
  as: Tag = 'h1',
  size,
  sizeScrolled,
  className = '',
  children,
  ...rest
}) => {
  const scrolled = useContext(HeaderScrollContext);
  return (
    <Tag
      className={[
        'm-0 transition-all duration-300 ease-mogged',
        className,
        scrolled ? sizeScrolled : size,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default HeaderTitle;
